import { MultiValue, SingleValue } from 'chakra-react-select';
import { Select, SelectOption, SelectProps } from 'components/UI';

export type DropDownProps = {
  selectValue: string;
  filterData: string[];
  value: string | undefined;
  setFilteredData(a: string, b: string): void;
} & SelectProps;

const DropDown = ({ name, selectValue, filterData, value, setFilteredData, ...props }: DropDownProps) => {
  const handleChange = (newValue: MultiValue<string | SelectOption> | SingleValue<string | SelectOption>) => {
    setFilteredData(selectValue, (newValue as SingleValue<SelectOption>)?.value ?? '');
  };

  return (
    <Select
      name={name}
      value={value ? { value, label: value } : null}
      onChange={handleChange}
      options={filterData.map((data) => ({ label: data, value: data }))}
      overrideStyles={{
        control: {
          bgColor: 'white',
        },
      }}
      {...props}
    />
  );
};

export default DropDown;
